import { Link, Outlet } from 'react-router-dom'
import Layout from 'antd/lib/layout'
import Flex from 'antd/lib/flex'
import { Button, Typography } from 'antd'
import { createLocators, paths } from '@/shared'
import { useAuthStore, useUserInfoStore } from '@/store'

const { Header, Content } = Layout

const { locators: locator } = createLocators({
  name: 'Layout',
  componentLocators: ['root', 'header', 'sider', 'content'],
})()

export const BaseLayout = () => {
  const { logout } = useAuthStore((state) => state)
  const { info } = useUserInfoStore((state) => state)

  const logoutHandler = () => {
    logout()
  }

  return (
    <Layout {...locator.root()}>
      <Header
        {...locator.header()}
        style={{ background: 'transparent', padding: '0', height: 'auto', marginBottom: 20 }}>
        <Flex align='center' style={{ background: 'white', height: '100%', padding: 20 }} justify='space-between'>
          <Link to={paths.main()}>
            <Typography.Title level={3} style={{ margin: 0 }}>
              Billing Dashboard
            </Typography.Title>
          </Link>
          <Flex gap={16} align='center' style={{ lineHeight: 1 }}>
            {info.name}
            <Button onClick={logoutHandler}>Logout</Button>
          </Flex>
        </Flex>
      </Header>
      <Layout style={{ minHeight: 'calc(100vh - 88px)' }}>
        <Content
          {...locator.content()}
          style={{
            maxWidth: 1440,
            margin: '0 auto',
            width: '100%',
            padding: '0px 8px',
            minHeight: 280,
          }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
